export const LOGOUT_NEAR = 'logoutNear';
export const LOGIN_NEAR = 'loginNear';
export const CLICK_HAMBURGER = 'clickHamburger';
